import { UsersContract } from '@terra/shared-contracts-users';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'gateway';

export const usersClient = createTerraOrpcClient({
  contract: UsersContract,
  serviceName: SERVICE_NAME,
});
